// @flow
import axios from 'axios';
import { CONTENTFUL_PATH } from '../constants';

const NAMESPACE = '@@paidy.com/consumer_faq_categories_order';

export const REQUEST_FAQ = `${NAMESPACE}/request_faq`;
export const RECEIVE_FAQ_SUCCESS = `${NAMESPACE}/receive_faq_success`;
export const RECEIVE_FAQ_FAIL = `${NAMESPACE}/receive_faq_fail`;

const initialState = {};

const reducer = (state: Object = initialState, action: Object) => {
  switch (action.type) {
    case REQUEST_FAQ: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case RECEIVE_FAQ_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        data: action.consumerFaqCategoriesOrder,
        updatedAt: action.updatedAt,
      };
    }
    default: {
      return state;
    }
  }
};

// consumer campaigns
const requestConsumerFAQCategoriesOrder = () => {
  return {
    type: REQUEST_FAQ,
  };
};

const receiveConsumerFAQCategoriesOrder = (data) => {
  return {
    type: RECEIVE_FAQ_SUCCESS,
    consumerFaqCategoriesOrder: data || [],
    updatedAt: Date.now(),
  };
};

const _fetchConsumerFAQCategoriesOrder = () => {
  return (dispatch: Function) => {
    dispatch(requestConsumerFAQCategoriesOrder());

    return axios
      .get(`${CONTENTFUL_PATH}consumer-faq-categories-order.json`)
      .then((resp) => dispatch(receiveConsumerFAQCategoriesOrder(resp.data)))
      .catch(console.error);
  };
};

export const fetchConsumerFAQCategoriesOrder = () => {
  return (dispatch: Function) => dispatch(_fetchConsumerFAQCategoriesOrder());
};

export default reducer;
